// This list contains localized strings that are not available in the backend.
// These strings are required as a fallback because they might not be useful in the future due to outdated design.
// Additionally, these strings are also old and may be deprecated in upcoming versions.

import { MyList } from "@/screens/myList/MyList";
import { Search } from "lucide-react";
import { generateDialectNamesFallback } from "@/config/dialects.config";

export const fallbackCopies = {
  hi: {
    common: {
      viewInFullScreen: "फुलस्क्रीन में देखें",
      off: "ऑफ",
      viewMore: "और देखें",
      viewLess: "कम देखें",
      shows: "शोज़",
      movies: "फिल्में",
      readMore: "...पूरा देखें",
      readLess: "...कम देखें",
      home: "होम",
      new: "नया",
      myList: "मेरी लिस्ट",
      search: "सर्च",
      categories: "कैटेगरी",
      allCategories: "सभी कैटेगरी",
      selectCategory: "कैटेगरी चुनें",
      dramaShorts: "ड्रामा शॉर्ट्स",
      noContentAvailable: "कोई कंटेंट उपलब्ध नहीं है",
      checkBackLater: "कृपया बाद में दोबारा देखें",
      all: "सभी",
      moviesOnly: "फिल्में",
      showsOnly: "शोज़",
      trailer: "%d ट्रेलर",
      trailer_title: "%d - आधिकारिक ट्रेलर",
      tryAgain: "दुबारा प्रयास करें",
      trial: "ट्रायल",
      subscription: "सब्सक्रिप्शन",
      active: "एक्टिव",
      valid_till: "%d तक मान्य",
      plan: "प्लान %d",
      days: "%d दिन",
      months: "%d महीने",
      pause_mandate: "पॉज ऑटोपे",
      resume_mandate: "रिज्यूम ऑटोपे",
      please_wait: "कृपया प्रतीक्षा करें...",
      seasons: "%d सीज़न्स",
      episodes: "%d एपिसोड्स",
      episode: "%d एपिसोड",
      preview: "प्रीव्यू",
      paywallTitle: "खास ऑफर सिर्फ आज के लिए!",
      paywallHighlightedTitle: "सिर्फ आज के लिए!",
      faq: "अक्सर पूछे जाने वाले प्रश्न",
      microdrama_episode: "एपिसोड",
      microdrama_epsidoes: "एपिसोड्स",
      more: "अन्य",
      edit: "एडिट",
      loading: "लोडिंग...",
    },
    myList: {
      nonLoggedInTitle: "लॉगिन आवश्यक",
      nonLoggedInDescription:
        "अपनी फेवरेट हिट्स को लिस्ट में जोड़ने हेतु लॉगिन करें",
      nonLoggedInPrimaryCta: "अभी लॉगिन करें",
      noItemsTitle: "यहां कुछ नहीं है!",
      noItemsDescription: "अभी ब्राउज़ करें और अपने पसंदीदा को सेव करें",
      noItemsPrimaryCta: "ब्राउजिंग शुरू करें",
      failToLoadTitle: "लिस्ट लोड नहीं की जा सकी",
      failToLoadDescription:
        "माफ कीजिए, तकनीकी कारणों से लिस्ट लोड नहीं हो सकी। आपकी लिस्ट लोड नहीं हो पाई। कृपया फिर से कोशिश करें।",
      failToLoadPrimaryCta: "दुबारा प्रयास करें",
      failToLoadSecondaryCta: "अन्य टॉप हिट्स देखें",
      addToMyListSuccess: "मेरी लिस्ट में ऐड हुआ",
      removeFromMyListSuccess: "मेरी लिस्ट से हटाया गया",
      addToMyListTooltip: "मेरी लिस्ट में ऐड करें",
      removeFromMyListTooltip: "मेरी लिस्ट से हटाएं",
    },
    movies: {
      description: "अपने मूड के लिए परफेक्ट फिल्म खोजें!",
    },
    shows: {
      description: "देखने के लिए परफेक्ट सीरीज़ खोजें!",
    },
    content_info: {
      duration_text: "फिल्म लगभग %d तक चलती है।",
      duration_not_available: "अवधि की जानकारी उपलब्ध नहीं है।",
      age_rating: "U/A 13+",
      region: "भारत",
      tv_show: "टीवी शो",
    },

    search: {
      text_field_label: 'सर्च करें "%d"',
      hint_for_searching: "सर्च करें...",
      special_for_you: "खास आपके लिए",
      top_searches: "टॉप सर्च रिजल्ट्स",
      search_result: 'सर्च रिजल्ट "%d"',
      // for tv
      search_result_for_tv: '"%d" के लिए रिजल्ट्स',
      no_results_found: "कोई रिजल्ट नहीं मिला",
      suggested_for_you: "खास आपके लिए",
    },
    consumption_page: {
      now_playing: "अभी चल रहा है",
      quality: "क्वालिटी",
      playback_speed_text: "प्ले बैक स्पीड",
      subtitles: "सबटाइटल",
      next_episode: "अगला एपिसोड",
      watch_credits: "क्रेडिट्स देखें",
      skip_intro: "इंट्रो स्किप करें",
      replay: "रीप्ले",
      forward_tooltip: "%d सेकंड आगे",
      rewind_tooltip: "%d सेकंड पीछे",
      enter_fullscreen_tooltip: "एंटर फुलस्क्रीन",
      exit_fullscreen_tooltip: "एग्जिट फुलस्क्रीन",
      play_tooltip: "प्ले",
      pause_tooltip: "पॉज",
      unmute_tooltip: "म्यूट हटाएं",
      mute_tooltip: "म्यूट करें",
      login_reminder_toast: "मिनट में लॉगिन करें ताकि आप देखना जारी रख सकें",
    },
    setting_page: {
      title: "सेटिंग्स",
      greeting: "राम राम",
      accordian_title: "हमारे बारे में और नीति",
      career: "करियर",
      purchase_trial: "ट्रायल शुरू करें",
      manage_subscription: "सब्सक्रिप्शन मैनेज करें",
      purchase_subscription: "सब्सक्रिप्शन खरीदें",
      about_us: "हमारे बारे में",
      privacy_policy: "गोपनीयता नीति",
      contact_us: "संपर्क करें",
      welcomeMessage: "STAGE पर आपका स्वागत है",
      welcomeMessageDescription:
        "अपनी प्रोफ़ाइल को वैयक्तिकृत करें, अपनी पहचान की कहानियों को अनलॉक करें, और अपनी क्रांति का हिस्सा बनें।",
    },
    // Auto-generated from DIALECT_CONFIGS - adds new dialects automatically
    dialects: generateDialectNamesFallback("hi"),
    home_page: {
      login_tv_success: "Stage में सफलतापूर्वक लॉगिन हो गया!",
      header_right: {
        start_trial: "ट्रायल शुरू करें",
        purchase_subscription: "सब्सक्रिप्शन खरीदें",
      },
      footer: {
        col1Title: "हरियाणवी में लोकप्रिय",
        col2Title: "राजस्थानी में लोकप्रिय",
        col3Title: "भोजपुरी में लोकप्रिय",
        col4Title: "गुजराती में लोकप्रिय",
        col5Title: "कंपनी",
        col6Title: "सहायता और समर्थन",
        compliance_report: "अनुपालन रिपोर्ट",
        connect_with_us: "हमसे जुड़ें:",
        website_language: "वेबसाइट की भाषा:",
      },
    },
    auth_screen: {
      verify_otp_sent_on_new: "%d पर भेजा गया OTP दर्ज करें",
      enter_mobile_number: "मोबाइल नंबर दर्ज करें",
      verify_otp_sent: "ओ टी पी भेज दिया गया हैं...",
      resend_otp_sent: "OTP दोबारा भेजा जा चुका है।",
      resent_otp_in: " %d में OTP फिर से भेजें।",
      please_wait: "कृपया प्रतीक्षा करें...",
      submit_otp: "ओ टी पी जमा करें",
      login_with: "या कनेक्ट करें",
      login_not_allowed_subscription_not_active:
        "%d पर सदस्यता सक्रिय नहीं है। जारी रखने के लिए कृपया STAGE मोबाइल ऐप या वेबसाइट का उपयोग करके सदस्यता लें",
      phone_number_error_msg: "कृपया सही मोबाइल नंबर दर्ज करें",
      resend_otp_button_text: "OTP दोबारा भेजें",
      privacy_terms_confirmation: "आगे बढ़ने पर आप हमारी",

      privacy_policy_hi: "गोपनीयता नीति",
      terms_of_use_new: "नियम व शर्तों",
      privacy_terms_suffix: "से सहमति देते हैं।",
      qr_scan_title: "कैमरा ऐप का उपयोग करके QR कोड स्कैन करें",
      qr_link_instruction: "STAGE मोबाइल ऐप पर रीडायरेक्ट करने के लिए ",
      qr_redirect_instruction: "जनरेट किए गए लिंक पर क्लिक करें",
      login_to: "मे लॉगिन करें",
      login_subtitle:
        "लॉगिन करने के लिए QR कोड स्कैन करें या फोन नंबर दर्ज करें",
      back_button_text: "वापस जाएँ",
      back_button_text_tv: "नंबर बदलें",
      get_otp_text: "OTP प्राप्त करें",
      search_country: "देश खोजें...",
      no_results_found: "कोई परिणाम नहीं मिला",
    },
    truecaller_login: {
      fallback_message:
        "Truecaller इंस्टॉल है तो ऐप खुलेगा, वरना मोबाइल नंबर से लॉगिन करें।",
    },
    content_detail: {
      season: "सीज़न",
      resume_watching_show: "%d देखना जारी रखें",
      resume_watching_movie: "देखना जारी रखें",
      mandate_paused_toast:
        "आपका ट्रायल रुका हुआ है , कंटेंट देखने के लिए ट्रायल दुबारा शुरू करें।",
      similar_shows_title: "मिलता जुलता कंटेंट",
      all_content_title: "सभी कंटेंट",
      start_watching_cta: "देखना शुरू करें",
      app_download_popup: "/static/app_update_popup_image_hi.png",
      watch_season_trailer: "%d ट्रेलर देखें",
      remaining_time: "%d बाकी",
      more_like_this_title: "मिलता जुलता कंटेंट",
      play_from_beginning_title: "शुरुआत से देखें",
    },
    checkout_screen: {
      heading_web: "भुगतान करें",
      plan_price: "प्लान प्राइस",
      plan_validity: "%d तक मान्य",
      payment_options_heading: "UPI से भुगतान करें",
      status_loading_label: "लोड हो रहा है...",
      payment_pool: {
        heading: "कृपया भुगतान पूरा होने तक बैक या रिफ्रेश ना करें।",
        sub_heading:
          "भुगतान की स्थिति की जाँच हो रही है, कृपया प्रतीक्षा करें।",
        remainig_time: "शेष समय",
        minute: "मिनट",
      },
      coupon: {
        heading: "कूपन",
        descrption_part_one: "आपको %d दिनों का ट्रायल मिला",
        description_part_two: "के द्वारा",
      },
      payViaQr: {
        heading: "किसी भी UPI ऐप से भुगतान करें",
        view_qr: "QR देखें",
        reload_qr: "नया QR देखें",
        valid_till: "QR सिर्फ %d तक वैध",
        qr_expired: "QR अवधि समाप्त!",
        upi_info_text:
          "GooglePay, PhonePe, Paytm आदि जैसे किसी भी ऑटोपे सक्षम UPI ऐप का उपयोग करके इस QR को स्कैन करें।",
      },
      tv: {
        trial: {
          title: "जारी रखने के लिए ट्रायल प्लान खरीदें",
          post_trial_msg:
            "%d दिन का ट्रायल सिर्फ ₹%d में. उसके बाद हर %d महीने का खर्च ₹%d होगा, जो अपने आप कट जाएगा.",
        },
        subscription: {
          title: "जारी रखने के लिए %d महीने का प्लान खरीदें",
          post_subscription_msg: "₹%d, हर %d महीने में अपने आप रिन्यू होगा।",
          incentive_post_subscription_msg:
            "%d दिनों का सब्सक्रिप्शन सिर्फ ₹%d में. उसके बाद हर %d महीने का खर्च ₹%d होगा, जो अपने आप कट जाएगा.",
        },
        payViaQr: {
          title: "किसी भी UPI ऐप से भुगतान करें",
          paymentAppsInfo:
            "किसी भी ऑटोपे सक्षम UPI ऐप जैसे GooglePay, PhonePe, Paytm आदि का उपयोग करके QR को स्कैन करें।",
        },
      },
      payment_failed_banner: {
        sub_heading: "पेमेंट असफल हुआ",
        heading: "सिर्फ %d%d काटा जाएगा। फिर से कोशिश करें",
        note: "<b>नोट:</b> अगर अमाउंट कट गया है, तो ऑटोमैटिकली रिफंड हो जाएगा।",
      },
      payNow: "अभी भुगतान करें",
      payment_retry_modal: {
        title: "पेमेंट नहीं हो पाया",
        subtitle: "चिंता न करें, कोई राशि नहीं कटी।",
        trial_price_label: "आपका ट्रायल सिर्फ",
        plan_price_label: "आपका प्लान सिर्फ",
        opening: "खोल रहे हैं",
      },
      payment_failed_message: "भुगतान असफल हुआ। कृपया फिर से कोशिश करें।",
      pay_by_card: "कार्ड से भुगतान करें - %d",
      payment_options_heading_card: "कार्ड से भुगतान करें",
      payment_options_heading_generic: "भुगतान विकल्प",
    },
    tvAdoption: {
      helpButtonText: "क्या आपको सेटअप मेदद चाहिए?",
      callsupportText: "हमारे एजेंट्स से तुरंत सहायता चाहिए? बस हमें कॉल करें!",
      callsupportButtonText: "हमें कॉल करें",
    },
    subscription_page: {
      primary_cta: "₹ %d /- का रिचार्ज करें",
      primary_cta_international: "%d का रिचार्ज करें",
      heading_web: "रिचार्ज करें",
      plan_price_info: "₹%d/-",
      footer_text:
        "निर्बाध मनोरंजन का आनंद लेने के लिए, आपकी सदस्यता %d को ऑटो-रिन्यू होगी, आप इसे कभी भी रद्द कर सकते हैं",
    },
    faq: {
      heading: "रिचार्ज के बारे में कोई सवाल है?",
    },
    tnpl_2: {
      popups: {
        failurePopup: {
          subscription_retry_button_text: "सब्सक्राइब करें",
        },
      },
      tnpl_screen: {
        screen_title_first_part: "%d दिन का ट्रायल ऑफर",
        coupon_status_popup: {
          valid_coupon_description: "कूपन कोड लागु कर दिया गया है",
          invalid_coupon_description: "अमान्य कूपन कोड",
        },
      },
    },
    payment_success_page: {
      trial_started: "आपका ट्रायल शुरू हो गया हैं",
      trial_secondary_text:
        "ट्रायल समाप्त होने के बाद, आपका 3 महीने का रिचार्ज %d को होगा।",
      subscription_secondary_text: "%d दिन का रिचार्ज लागु प्लान %d तक मान्य",
      app_download_image: "/static/play-store-download-app-hi.png",
      tv: {
        trial_validity: "ट्रायल %d तक मान्य",
        subscription_validity: "सब्सक्रिप्शन %d तक मान्य",
        payment_failed: "भुगतान असफल",
        payment_successful: "भुगतान सफल",
        retry_cta: "दुबारा कोशिश करें",
        return_to_home_cta: "होम पर लौटें",
      },
      mobile: {
        payment_successful: "भुगतान सफल",
        trial_secondary_text: "आपका %d दिन का ट्रायल शुरू हो गया है",
        startWatchingBtnLabel: "देखना शुरू करें",
        benefitsList: {
          0: "आपने 11,450 घंटे का कॉन्टेंट अनलॉक किया",
          1: "रणदीप का एक्सक्लूसिव कंटेंट अनलॉक हो गया है!",
          2: "बेहतर अनुभव के लिए STAGE ऐप पर देखें",
        },
      },
    },
    not_found_screen: {
      heading: "रास्ता भटक गए?",
      description:
        "माफ़ करें, हमें यह पेज नहीं मिल रहा है। आप होम पेज पर जाकर बहुत कुछ देख सकते हैं।",
      cta: "STAGE होम पर जाए",
    },
    error_screen: {
      heading: "असुविधा के लिए खेद है।",
      description: "हमारी सेवा अभी उपलब्ध नहीं है। कृपया बाद में प्रयास करें।",
      cta: "दुबारा कोशिश करें",
    },
    dialect_selector: {
      cta: "आगे बढ़ें",
    },
    popups: {
      logout: {
        heading: "क्या आप लॉगआउट करना चाहते है ?",
        cancelCta: "नहीं",
        confirmCta: "हाँ",
        logoutCta: "लॉगआउट",
      },
      subscribeToWatch: {
        title: "देखने के लिए सब्सक्राइब करें",
        description:
          'यह वीडियो केवल प्रीमियम यूज़र के लिए उपलब्ध है। 150+ हरियाणवी हिट्स जैसे "%d" का आनंद लेने के लिए अभी सब्सक्राइब करें।',
        cta: "सब्सक्राइब करें",
      },
      appDownloadBanner: {
        heading1: "बेहतर अनुभव के लिए",
        heading2: "STAGE ऐप पर देखें",
        subHeading: "4.8 ⭐️ | 50M+ डाउनलोड्स",
        cta: "ऐप खोलें",
      },
      appOpenDrawer: {
        heading: "STAGE ऐप पर देखें",
        subHeading: "बेहतर अनुभव के लिए",
        text: "4.8 ⭐️ | 50M+ डाउनलोड्स",
        buttonText: "ऐप खोलें",
        continueWatching: {
          heading: "STAGE ऐप पर देखना जारी रखें",
        },
      },
      locationChange: {
        title: "लोकेशन बदलाव डिटेक्ट हुआ",
        subtitle: "आपकी सब्सक्रिप्शन सिर्फ भारत में मान्य है",
        body: "आप दूसरे देशों में कोई भी कंटेंट एक्सेस नहीं कर पाएंगे। सभी शोज़, वीडियो और मूवीज़ का आनंद लेने के लिए आपको अपना प्लान ग्लोबल प्लान में अपग्रेड करना होगा।",
        upgradeCta: "अभी अपग्रेड करें",
        dismissCta: "अभी नहीं",
      },
    },
    genreDetail: {
      heading: "शानदार %d का मज़ा",
      popularHits: "पॉपुलर हिट्स",
      popularMovies: "पॉपुलर फिल्में",
      popularShows: "पॉपुलर शोज़",
      popularGenres: "पॉपुलर जेनर्स",
      otherGenres: "अन्य जेनर्स",
    },
    profile_assets: {
      who_is_watching: "अपनी प्रोफाइल चुनें",
      loading_profiles: "प्रोफ़ाइल लोड हो रही है...",
      add_details_to_create_profile: "प्रोफाइल बनाने के लिए डिटेल्स ऐड करें",
      max_profiles_reached: "अधिकतम प्रोफ़ाइल पंजीकृत है",
      max_profiles_reached_description:
        "आपने अधिकतम संख्या में प्रोफ़ाइल पंजीकृत कर दिया है।",
      return_to_home_cta: "होम पर लौटें",
      create_profile_heading: "नई प्रोफाइल बनाएं",
      choose_your_avatar: "अपना अवतार चुनें",
      name_input_placeholder: "प्रोफ़ाइल नाम",
      update_profile_cta: "प्रोफ़ाइल अपडेट करें",
      create_profile_text: "प्रोफ़ाइल बनाएं",
      edit_profile_text: "अपनी प्रोफाइल एडिट करें",
      edit_profile_heading: "एडिट प्रोफाइल",

      select_content_culture_text: "कंटेंट संस्कृति चुनें",
      select_language_text: "अपनी भाषा चुनें",
      add_profile: "प्रोफ़ाइल जोड़ें",
      add_new: "नया जोड़ें",
      profiles_title: "प्रोफ़ाइल्स",
      tv: {
        set_app_language_text: "एप भाषा सेट करें",
        save_text: "सेव करें",
        change_profile_text: "प्रोफ़ाइल बदलें",
        change_avatar_text: "अवतार बदलें",
      },
      back_button: {
        text: "वापस जाएं",
      },
      back_confirmation_title: "क्या आप वाकई वापस जाना चाहते हैं?",
      back_confirmation_description:
        "यदि आप वापस जाते हैं, तो अब तक किया गया सारा काम मिट जाएगा।",
      back_confirmation_cancel: "रद्द करें",
      back_confirmation_confirm: "वापस जाएं",
      change_your_avatar_text: "अपना अवतार बदलें",
      choose_avatar_for_profile_text: "अपने प्रोफ़ाइल के लिए अवतार चुनें",
    },
    commonHome: {
      top10Haryanvi: "हरियाणवी में लोकप्रिय",
      top10Rajasthani: "राजस्थानी में लोकप्रिय",
      top10Bhojpuri: "भोजपुरी में लोकप्रिय",
      top10Gujarati: "गुजराती में लोकप्रिय",
      familyKaTVTime: "फ़ैमिली का TV टाइम",
      comedyKaTadka: "कॉमेडी का तड़का",
      fansFavourites: "फैंस की पसंदीदा",
      aansuAurEhsas: "आंसू और एहसास",
      eyeOpeners: "आँखें खोल देने वाली",
      yaaronKaAdda: "यारों का अड्डा",
      mazaedarShows: "वेब सीरीज",
      select_culture: "संस्कृति चुनें",
      all: "सभी",
    },
    start_trial_banner: {
      heading: {
        trialEligible: "500+ HD मूवीज़/शोज़ अनलॉक करें ₹1 में",
        notTrialEligible: "500+ HD मूवीज़/शोज़ अनलॉक करें",
      },
      cta: "अभी देखें",
    },
    spin_the_wheel: {
      heading: "पाएं 90% OFF",
      description: "स्पिन करें - %s और 500+ फ़िल्में और शो अनलॉक करें",
      claim_now_cta: "अभी क्लेम करें",
      for: "में",
      days: "दिन",
      expires_in_text: "समाप्त होगा %d",
      spin_cta: "स्पिन करें",
      login_title: "लॉगिन करें और ऑफर क्लेम करें",
      limited_offer: "सीमित ऑफर",
    },
    hammer_crack: {
      heading: "पाएं 99% OFF",
      subheader: "डायमंड तोड़कर अनलॉक करें",
      subheader_suffix: "और 500+ फिल्में और शो",
      subheader_no_content: "डायमंड तोड़कर 500+ फिल्में और शो अनलॉक करें",
      break_button: "तोड़ें",
      break_again_button: "फिर से तोड़ें",
      claim_button: "अभी क्लेम करें",
      login_title: "लॉगिन करें और ऑफर क्लेम करें",
    },
    contact_us: {
      contactUs: "संपर्क करें",
      headContent: "हमें आपकी किसी भी समस्या का समाधान करने में ख़ुशी मिलती है",
      subHeading: "समर्थन • सहायता केंद्र • प्रतिक्रिया",
      emailTitle: "हमें ईमेल करें",
      emailContent: "हमारी टीम मदद करने के लिए यहा है",
      emailButtonText: "हमें ईमेल करें",
      cgoTitle: "चीफ ग्रीवांस अफसर",
      cgoPerson: "विनय सिंघल",
      cgoContent:
        "हमारी टीम को यहाँ ईमेल करें, ईमेल में अपना फ़ोन नंबर का भी उल्लेख करें",
      cgoButtonText: "CGO को लिखें",
      phoneTitle: "फ़ोन",
      phoneContent: "सुबह 9 बजे से 7 बजे के बीच कॉल करें",
      phoneButtonText: "कॉल करें",
    },
    free_watch_flow: {
      login_title: "लॉगिन करें और देखना जारी रखें",
      login_subtitle: "लॉगिन करें और देखना जारी रखें",
    },
    expires_in_timer: {
      checkout_timer: {
        expires_in_text: "₹%d का ऑफर समाप्त होगा",
        limited_offer_text: "₹%d का ऑफर बढ़ा दिया गया है!",
      },
    },
    app_settings: {
      subscription_heading: "सब्सक्रिप्शन",
      settings_title: "सेटिंग्स",
      connecting: "ऐप से कनेक्ट हो रहा है...",
      loading: "सेटिंग्स लोड हो रही है...",
      error_title: "कुछ गलत हो गया",
      error_message: "कृपया बाद में प्रयास करें",
      whatsapp_support: "WhatsApp पर हमसे बात करें",
      whatsapp_support_description:
        "STAGE संबंधित किसी भी सवाल के लिए नीचे दिए गए बटन पर क्लिक करें",
      call_support: "मदद लें",
      app_control_title: "ऐप कंट्रोल",
      select_dialect: "कंटेंट संस्कृति चुनें",
      select_language: "ऐप्प की भाषा",
      register_tv: "रजिस्टर टीवी",
      tv_setup_guide: "टीवी सेटअप गाइड",
      legal_section_title: "कानूनी अनुभाग",
      about_us: "हमारे बारे में",
      career: "करियर",
      privacy_policy: "गोपनीयता नीति",
      terms_of_use: "नियम व शर्तें",
      refund_policy: "रिफंड पॉलिसी",
      contact_us: "संपर्क करें",
      logout: "लॉगआउट",
      app_version: "ऐप वर्शन",
    },
    characters: {
      page_subtitle: "अपने पसंदीदा किरदारों के साथ चैट करें",
      page_title: "किरदारों के साथ चैट करें | Stage OTT",
      page_description: "अपने पसंदीदा किरदारों के साथ चैट करें",
      no_image: "कोई छवि नहीं",
      character_singular: "किरदार",
      character_plural: "किरदार",
      content_type_movie: "फिल्म",
      content_type_show: "शो",
      watch_now_cta: "देखना शुरू करें",
    },
    hybrid_paywall: {
      recommended: "सुझाया गया",
      cancel_anytime: "कभी भी कैंसिल करें",
      choose_your_plan: "अपना प्लान चुनें",
      trial_plan: {
        title: "7-दिन का ट्रायल प्लान",
        subtitle: "पूरी लाइब्रेरी का एक्सेस",
        price_suffix: "सिर्फ",
        bottom_text: "*7 दिन बाद %d में 1 महीने का प्लान आटोमेटिक चालू होगा। ",
        cta_label: "ट्रायल शुरू करें",
      },
      subscription_plan: {
        title: "मासिक प्लान",
        subtitle: "पूरी लाइब्रेरी का एक्सेस",
        price_suffix: "/महीना",
        bottom_text: "%d 1 महीने का प्लान हर महीने अपने आप रिन्यू होगा।",
        cta_label: "सब्सक्रिप्शन शुरू करें",
      },
      "hybrid-paywall-content-grid": {
        heading_prefix: "देखें",
        heading_highlighted: "2000+ HD",
        heading_suffix: "फ़िल्में और शोज़",
      },
      "hybrid-paywall-gift": {
        heading_prefix: "स्पेशल डिस्काउंट",
        heading_highlighted: "केवल आज के लिए!",
        heading_suffix: "",
      },
      default: {
        heading_prefix: " ",
        heading_highlighted: " ",
        heading_suffix: " ",
      },
    },
  },

  en: {
    common: {
      viewInFullScreen: "View in full screen",
      off: "Off",
      viewMore: "View More",
      viewLess: "View Less",
      shows: "Shows",
      movies: "Movies",
      readMore: "...more",
      readLess: "...less",
      home: "Home",
      new: "NEW",
      myList: "My List",
      search: "Search",
      categories: "Categories",
      allCategories: "All Categories",
      selectCategory: "Select Category",
      dramaShorts: "Drama Shorts",
      noContentAvailable: "No content available",
      checkBackLater: "Please check back later",
      all: "All",
      moviesOnly: "Movies",
      showsOnly: "Shows",
      trailer: "%d Trailer",
      trailer_title: "%d - Official Trailer",
      tryAgain: "Try Again",
      trial: "Trial",
      subscription: "Subscription",
      active: "Active",
      valid_till: "Valid Till: %d",
      plan: "Plan: %d",
      days: "%d Days",
      months: "%d Months",
      pause_mandate: "Pause Autopay",
      resume_mandate: "Resume Autopay",
      please_wait: "Please wait...",
      seasons: "%d Seasons",
      episodes: "%d Episodes",
      episode: "%d Episode",
      preview: "Preview",
      paywallTitle: "Special Offer Only for today!",
      paywallHighlightedTitle: "Only for today!",
      faq: "Frequently Asked Questions",
      microdrama_episode: "Episode",
      microdrama_epsidoes: "Episodes",
      more: "More",
      edit: "Edit",
      loading: "Loading...",
    },
    myList: {
      nonLoggedInTitle: "Login Required",
      nonLoggedInDescription:
        "Login with your account to save and access your favourites in my list",
      nonLoggedInPrimaryCta: "Login Now",
      noItemsTitle: "Nothing here yet!",
      noItemsDescription: "Browse and save your favourites in my list now.",
      noItemsPrimaryCta: "Start Browsing",
      failToLoadTitle: "Unable to load Your List",
      failToLoadDescription:
        "Sorry, we couldn't load your list due to an error on our end. Please retry.",
      failToLoadPrimaryCta: "Retry Now",
      failToLoadSecondaryCta: "Watch Other Top Hits",
      addToMyListSuccess: "Successfully added to My List",
      removeFromMyListSuccess: "Removed from My List",
      addToMyListTooltip: "Add to My List",
      removeFromMyListTooltip: "Remove from My List",
    },
    movies: {
      description: "Find the Perfect Movie for Your Mood!",
    },
    shows: {
      description: "Discover the Perfect Series to Binge!",
    },
    content_info: {
      duration_text: "The movie runs for approximately %d.",
      duration_not_available: "Duration information is not available.",
      age_rating: "U/A 13+",
      region: "India",
      tv_show: "TV Show",
    },
    search: {
      text_field_label: 'Search for "%d"',
      hint_for_searching: "Search for...",
      special_for_you: "Special for you",
      search_result: 'Search result for "%d"',
      top_searches: "Top Searches",

      // tv
      search_result_for_tv: `Showing results for "%d"`,
      no_results_found: "No results found",
      suggested_for_you: "Suggested for you",
    },
    consumption_page: {
      quality: "Quality",
      subtitles: "Subtitles",
      playback_speed_text: "Playback Speed",
      next_episode: "Next Episode",
      watch_credits: "Watch Credits",
      skip_intro: "Skip Intro",
      replay: "Replay",
      forward_tooltip: "Forward %d Seconds",
      rewind_tooltip: "Rewind %d Seconds",
      enter_fullscreen_tooltip: "Enter Fullscreen",
      exit_fullscreen_tooltip: "Exit Fullscreen",
      play_tooltip: "Play",
      pause_tooltip: "Pause",
      unmute_tooltip: "Unmute",
      mute_tooltip: "Mute",
      now_playing: "Now Playing",
      login_reminder_toast: "minutes until Login required to continue watching",
    },
    setting_page: {
      welcomeMessage: "Welcome to Stage",
      welcomeMessageDescription:
        "Personalise your profile, unlock apni pehchaan ki stories, and be a part of apni Kranti.",
      title: "Settings",
      greeting: "Ram Ram",
      accordian_title: "Legal Section",
      career: "Career",
      purchase_trial: "Start Trial",
      manage_subscription: "Manage Subscription",

      purchase_subscription: "Buy Subscription",
      about_us: "About Us",
      privacy_policy: "Privacy Policy",
      contact_us: "Contact Us",
    },
    // Auto-generated from DIALECT_CONFIGS - adds new dialects automatically
    dialects: generateDialectNamesFallback("en"),
    home_page: {
      login_tv_success: "Successfully logged in to Stage!",
      header_right: {
        start_trial: "Start Trial",
        purchase_subscription: "Buy Subscription",
      },
      footer: {
        col1Title: "Popular in Haryanvi",
        col2Title: "Popular in Rajasthani",
        col3Title: "Popular in Bhojpuri",
        col4Title: "Popular in Gujarati",
        col5Title: "Company",
        col6Title: "Help & Support",
        connect_with_us: "Connect with us:",
        website_language: "View website in:",
        compliance_report: "Compliance Report",
      },
    },
    auth_screen: {
      verify_otp_sent_on_new: "Enter OTP sent to %d",
      enter_mobile_number: "Enter mobile number",
      verify_otp_sent: "OTP has been sent...",
      resend_otp_sent: "OTP has been resent.",
      resent_otp_in: "Resend OTP in %d",
      please_wait: "Please wait...",
      submit_otp: "Submit OTP",
      login_with: "or connect with",
      login_not_allowed_subscription_not_active:
        "Subscription not active on %d. Please subscribe using STAGE mobile app or website to continue",
      phone_number_error_msg: "Please enter valid mobile number",
      resend_otp_button_text: "Resend OTP",
      privacy_terms_confirmation: "By proceeding you confirm that you agree to",
      privacy_terms_prefix: "the",
      privacy_policy: "Privacy Policy",
      terms_of_use_new: "Terms of Use",
      qr_scan_title: "Use Camera App to Scan QR",
      qr_link_instruction: "Click on the link generated to",
      qr_redirect_instruction: "redirect to STAGE mobile app",
      login_to: "Login to",
      login_subtitle: "Scan QR code or enter phone number to login",
      back_button_text: "Back",
      back_button_text_tv: "Back & Edit ",
      get_otp_text: "Get OTP",
      search_country: "Search country...",
      no_results_found: "No results found",
    },
    truecaller_login: {
      fallback_message:
        "Truecaller app will open if installed, otherwise log in with your mobile number.",
    },
    content_detail: {
      season: "Season",
      mandate_paused_toast: "Your trial is paused. Restart to watch content.",
      resume_watching_show: "Resume %d",
      resume_watching_movie: "Resume Watching",
      similar_shows_title: "Similar Content",
      all_content_title: "All Content",
      start_watching_cta: "Start Watching",
      app_download_popup: "/static/app_update_popup_image_en.png",
      watch_season_trailer: "Watch %d Trailer",
      remaining_time: "%d left",
      more_like_this_title: "More Like This",
      play_from_beginning_title: "Play from beginning",
    },
    tvAdoption: {
      helpButtonText: "Need help with setup?",
      callsupportText:
        "Want instant assistance? Call us and we’ll help you setup",
      callsupportButtonText: "Call us",
    },
    checkout_screen: {
      heading_web: "Checkout",
      plan_price: "Plan Price",
      plan_validity: "Valid until %d",
      payment_options_heading: "Pay using UPI",
      status_loading_label: "Loading...",
      payment_pool: {
        heading:
          "Please do not go back or refresh until the payment is complete.",
        sub_heading: "Checking payment status, please wait.",
        remainig_time: "Remaining Time",
        minute: "Minute",
      },
      coupon: {
        heading: "Coupon",
        descrption_part_one: "You got a %d days trial",
        description_part_two: "by",
      },
      payViaQr: {
        heading: "Pay By Any UPI App",
        view_qr: "View QR",
        reload_qr: "Reload QR",
        valid_till: "Valid till %d",
        qr_expired: "QR Code Expired",
        upi_info_text:
          "Scan this QR using any autopay-enabled UPI app like GooglePay, PhonePe, Paytm etc.",
      },
      tv: {
        trial: {
          title: "Get a Trial to Continue Watching",
          post_trial_msg:
            "%d-day trial for ₹%d. After that, every %d months costs ₹%d, billed automatically.",
        },
        subscription: {
          title: "Get %d Months Plan to Continue Watching",
          post_subscription_msg: "₹%d, renews automatically every %d months.",
          incentive_post_subscription_msg:
            "%d days subscription for ₹%d. After that, every %d months costs ₹ %d, billed automatically.",
        },
        payViaQr: {
          title: "Scan QR code",
          paymentAppsInfo:
            "Pay with any UPI app like GooglePay, PhonePe, Paytm.",
        },
      },
      payment_failed_banner: {
        sub_heading: "Payment failed",
        heading: "Only %d%d will be deducted. Try again",
        note: "<b>Note:</b> If the amount was deducted, it will be refunded automatically.",
      },
      payNow: "Pay Now",
      payment_retry_modal: {
        title: "Payment didn\u2019t go through",
        subtitle: "Don\u2019t worry, no amount was deducted.",
        trial_price_label: "Your trial is just",
        plan_price_label: "Your plan is just",
        opening: "Opening",
      },
      payment_failed_message: "Payment failed. Please try again.",
      pay_by_card: "Pay by Card - %d",
      payment_options_heading_card: "Pay by Card",
      payment_options_heading_generic: "Payment Options",
    },
    subscription_page: {
      primary_cta: "Recharge with ₹ %d /-",
      primary_cta_international: "Recharge with %d",
      heading_web: "Recharge Now",
      plan_price_info: "₹%d/-",
      footer_text:
        "To enjoy uninterrupted entertainment, your subscription will auto-renew on %d, you can cancel this anytime",
    },
    faq: {
      heading: "Have any queries regarding recharge",
    },
    tnpl_2: {
      popups: {
        failurePopup: {
          subscription_retry_button_text: "Buy Subscription",
        },
      },
      tnpl_screen: {
        screen_title_first_part: "%d Days trial",
      },
    },
    payment_success_page: {
      trial_started: "Your trial has started",
      trial_secondary_text:
        "After the trial ends, your 3-month recharge will be on %d.",
      subscription_secondary_text:
        "%d days recharge applied plan valid until %d",
      app_download_image: "/static/play-store-download-app-en.png",
      tv: {
        trial_validity: "Trial valid till: %d",
        subscription_validity: "Subscription valid till: %d",
        payment_failed: "Payment Failed",
        payment_successful: "Payment Successful",
        retry_cta: "Retry",
        return_to_home_cta: "Return to Home",
      },
      mobile: {
        payment_successful: "Payment Successful",
        trial_secondary_text: "Your %d day trial has started.",
        startWatchingBtnLabel: "Start Watching",
        benefitsList: {
          0: "You've unlocked 11,450 hrs of content.",
          1: "Randeep's exclusive content unlocked",
          2: "For seamless experience Download App",
        },
      },
    },
    not_found_screen: {
      heading: "Lost your way",
      description:
        "Sorry, we can't find that page. You'll find lots to explore on the home page",
      cta: "STAGE Home",
    },
    dialect_selector: {
      cta: "Proceed",
    },
    popups: {
      logout: {
        heading: "Are you sure you want to Logout?",
        cancelCta: "No",
        confirmCta: "Yes",
        logoutCta: "Logout",
      },
      subscribeToWatch: {
        title: "Subscribe to Watch",
        description:
          "This video is for premium users only. Please subscribe to continue enjoying 150+ top haryanvi hits like %d.",
        cta: "Subscribe Now",
      },
      appDownloadBanner: {
        heading1: "For seamless experience",
        heading2: "Watch on STAGE App",
        subHeading: "4.8 ⭐️ | 50M+ Downloads",
        cta: "Open App",
      },
      appOpenDrawer: {
        heading: "Watch on STAGE App",
        subHeading: "For seamless experience",
        text: "4.8 ⭐️ | 50M+ Downloads",
        buttonText: "Open App",
        continueWatching: {
          heading: "Continue watching on STAGE App",
        },
      },
      locationChange: {
        title: "Location Change Detected",
        subtitle: "Your Subscription is only valid in India",
        body: "You will not be able to access any content in other countries. You have to upgrade your plan to Global plan to enjoy all shows, videos and movies on STAGE",
        upgradeCta: "Upgrade Now",
        dismissCta: "Not Now",
      },
    },
    genreDetail: {
      heading: "Enjoy Top %d Hits",
      popularHits: "Popular Hits",
      popularMovies: "Popular Movies",
      popularShows: "Popular Shows",
      popularGenres: "Popular Genres",
      otherGenres: "Other Genres",
    },
    profile_assets: {
      who_is_watching: "Who’s Watching?",
      loading_profiles: "Loading profiles...",
      add_details_to_create_profile: "Add details to Create Profile",
      max_profiles_reached: "Maximum Profiles Reached",
      max_profiles_reached_description:
        "You have reached the maximum number of profiles allowed.",
      return_to_home_cta: "Return to Home",
      create_profile_heading: "Create New Profile",
      choose_your_avatar: "Choose your Avatar",
      change_your_avatar_text: "Change your Avatar",
      choose_avatar_for_profile_text: "Choose avatar for your Profile",
      name_input_placeholder: "Profile Name",
      update_profile_cta: "Update Profile",
      create_profile_text: "Create Profile",
      edit_profile_text: "Edit your Profile",
      edit_profile_heading: "Edit Profile",
      edit_profile_button: {
        text: "Edit Profile",
      },
      back_button: {
        text: "Back",
      },
      back_confirmation_title: "Are you sure ?",
      back_confirmation_description:
        "Your changes will be lost if you go back.",
      back_confirmation_cancel: "Cancel",
      back_confirmation_confirm: "Go Back",
      select_content_culture_text: "Select your Content Culture",
      select_language_text: "Select your Language",
      add_profile: "Add Profile",
      add_new: "Add New",
      profiles_title: "Profiles",
      tv: {
        set_app_language_text: "Set app Language",
        save_text: "Save",
        change_profile_text: "Change Profile",
        change_avatar_text: "Change Avatar",
      },
    },
    commonHome: {
      top10Haryanvi: "Top in Haryanvi",
      top10Rajasthani: "Top in Rajasthani",
      top10Bhojpuri: "Top in Bhojpuri",
      top10Gujarati: "Top in Gujarati",
      familyKaTVTime: "Family Ka TV Time",
      comedyKaTadka: "Comedy Ka Tadka",
      fansFavourites: "Fans Favourites",
      aansuAurEhsas: "Aansu Aur Ehsas",
      eyeOpeners: "Eye Openers",
      yaaronKaAdda: "Yaaron Ka Adda",
      mazaedarShows: "Mazedar Shows",
      select_culture: "Select Culture",
      all: "All",
    },
    start_trial_banner: {
      heading: {
        trialEligible: "Unlock 500+HD movies & shows @ ₹1",
        notTrialEligible: "Unlock 500+HD, Ads-free movies & shows",
      },
      cta: "Watch Now",
    },
    spin_the_wheel: {
      heading: "Get upto 90% OFF",
      description: "Spin to unlock %s & 500+ movies & shows",
      claim_now_cta: "Claim Now",
      for: "for",
      days: "days",
      expires_in_text: "Expires in %d",
      spin_cta: "SPIN",
      login_title: "Login & Claim the offer",
      limited_offer: "Limited Offer",
    },
    hammer_crack: {
      heading: "Get upto 99% OFF",
      subheader: "Break the diamond to unlock",
      subheader_suffix: "& 500+ movies & shows",
      subheader_no_content: "Break the diamond to unlock 500+ movies & shows",
      break_button: "BREAK",
      break_again_button: "BREAK AGAIN",
      claim_button: "Claim Now",
      login_title: "Login & Claim the offer",
    },
    contact_us: {
      contactUs: "Contact Us",
      headContent: "We're happy to help you with any problem",
      subHeading: "Support • Help Center • Feedback",
      emailTitle: "Email Us",
      emailContent: "Our team is here to help",
      emailButtonText: "Email us",
      cgoTitle: "Chief Grievance Officer",
      cgoPerson: "Vinay Singhal",
      cgoContent:
        "Email our team here, please mention your phone number in the email",
      cgoButtonText: "Write to CGO",
      phoneTitle: "Phone",
      phoneContent: "Call between 9 AM to 7 PM",
      phoneButtonText: "Call",
    },
    free_watch_flow: {
      login_title: "Login to continue watching",
      login_subtitle: "Enter your mobile number",
    },
    expires_in_timer: {
      checkout_timer: {
        expires_in_text: "₹%d offer expires in",
        limited_offer_text: "₹%d Offer extended for you!",
      },
    },
    app_settings: {
      subscription_heading: "Subscription",
      settings_title: "Settings",
      connecting: "Connecting to app...",
      loading: "Loading settings...",
      error_title: "Something went wrong",
      error_message: "Please try again later",
      whatsapp_support: "Chat with us on WhatsApp",
      whatsapp_support_description:
        "For any queries related to STAGE please click on the button below",
      call_support: "Take Help",
      app_control_title: "App Controls",
      select_dialect: "Select Content Culture",
      select_language: "App Language",
      register_tv: "Register TV",
      tv_setup_guide: "TV Setup Guide",
      legal_section_title: "Legal Section",
      about_us: "About Us",
      career: "Career",
      privacy_policy: "Privacy Policy",
      terms_of_use: "Terms of Use",
      refund_policy: "Refund Policy",
      contact_us: "Contact Us",
      logout: "Logout",
      app_version: "App Version",
    },
    characters: {
      page_subtitle: "Chat with your favorite characters",
      page_title: "Chat with Characters | Stage OTT",
      page_description: "Chat with your favorite characters",
      no_image: "No Image",
      character_singular: "Character",
      character_plural: "Characters",
      content_type_movie: "Movie",
      content_type_show: "Show",
      watch_now_cta: "WATCH NOW",
    },
    hybrid_paywall: {
      recommended: "Recommended",
      cancel_anytime: "Cancel anytime",
      choose_your_plan: "Choose your plan",
      trial_plan: {
        title: "7-Day Trial Plan",
        subtitle: "Full Access to library",
        price_suffix: "only",
        bottom_text: "After 7 days, %d for 1 month will start automatically",
        cta_label: "Start trial",
      },
      subscription_plan: {
        title: "Monthly Plan",
        subtitle: "Full Access to library",
        price_suffix: "/month",
        bottom_text: "%d for 1 month plan will auto-renew every month.",
        cta_label: "Start subscription",
      },
      "hybrid-paywall-content-grid": {
        heading_prefix: "Watch",
        heading_highlighted: "2000+ HD",
        heading_suffix: "Movies & Shows",
      },
      "hybrid-paywall-gift": {
        heading_prefix: "Special Discount",
        heading_highlighted: "Only for today!",
        heading_suffix: "",
      },
      default: {
        heading_prefix: " ",
        heading_highlighted: " ",
        heading_suffix: " ",
      },
    },
  },
};
